
import { defineComponent } from 'vue';
import { ThemeName } from '~/store/types';
import BenefitsList from '~/components/Nodes/BenefitsList.vue';
import NodesHeroVideo from '~/components/Nodes/NodesHeroVideo.vue';
import PageBottomCtas from '~/components/Nodes/PageBottomCtas.vue';
import RewardsSteps from '~/components/Nodes/RewardsSteps.vue';
import StatsList from '~/components/Nodes/StatsList.vue';
import PopcornExplainer from '~/components/Nodes/PopcornExplainer.vue';
import { buildI18nRouteMeta } from '~/utils/htmlHead';

export default defineComponent({
  components: {
    BenefitsList,
    NodesHeroVideo,
    PageBottomCtas,
    RewardsSteps,
    StatsList,
    PopcornExplainer,
  },
  head() {
    return buildI18nRouteMeta(
      this,
      'https://static.gala.games/gala-film/images/og-images/Nodes_Thumnail_1200x630.png',
    );
  },
  meta: {
    theme: ThemeName.DARK,
  },
});
